import { render, staticRenderFns } from "./FaceMergeModal.vue?vue&type=template&id=3e85a41f&scoped=true"
import script from "./FaceMergeModal.vue?vue&type=script&lang=ts"
export * from "./FaceMergeModal.vue?vue&type=script&lang=ts"
import style0 from "./FaceMergeModal.vue?vue&type=style&index=0&id=3e85a41f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e85a41f",
  null
  
)

export default component.exports